export default __webpack_public_path__ + "static/Guides_3-90e7cd83c91a020b7fc44abb3c5f751f.webp";